export default {
  "content": "<path d=\"M13 17h-2v-5.5h2V17zM12 6.5a1.5 1.5 0 110 3 1.5 1.5 0 010-3z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.929 4.929c3.905-3.905 10.237-3.905 14.142 0 3.906 3.905 3.906 10.237 0 14.142-3.905 3.906-10.237 3.906-14.142 0-3.905-3.905-3.905-10.237 0-14.142zm12.728 1.414A8 8 0 106.343 17.658 8 8 0 0017.657 6.343z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};